import { UserContext } from '../user-context.model';

export type UserContextStatus = 'idle' | 'loading' | 'loaded' | 'error';

export interface UserContextState {
  context: UserContext | null;
  status: UserContextStatus;
  error: string | null;
}

export const initialUserContextState: UserContextState = {
  context: null,
  status: 'idle',
  error: null,
};
